import { render, staticRenderFns } from "./medecins.specialite.vue?vue&type=template&id=000d38ce&"
import script from "./medecins.specialite.vue?vue&type=script&lang=js&"
export * from "./medecins.specialite.vue?vue&type=script&lang=js&"
import style0 from "./medecins.specialite.vue?vue&type=style&index=0&id=000d38ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports